import {
    a,
    getDisplayedShapes,
    getSelectedShapes,
    getMode,
    resetSelectedShapes,
    selectIfMouseInShapeBoundary, setMode
} from "../shared/globalState/a";
import { t } from '../shared/globalState/t';
import { checkFunction, getColor } from "../shared/common";
import { drawSingle } from "../shared/render/shapes";
import { addTooltipInfo } from "./tooltip";
import { CommandList as cl } from "../models/CommandList";
import { ObjectTypes } from "../shared/enums";

export function colorMagnetsObserver(mouse, shapes) {
    /**
     * Функция нужна для раскрашивания ручек
     */
    if (a.isMouseDown) {
        return;
    }

    else if (['move', 'copy', 'rotate', 'rotatecopy', 'mirror', 'scale', 'move-route-part'].includes(getMode())) {
        const color = getColor(212, 39, 216, 1);
        shapes.filter(shape => shape.isSelected).forEach(shape => {
            switch (shape.type) {
                case ObjectTypes.line:
                    if (shape.isinGripStart(mouse) || shape.isinGripEnd(mouse) || shape.isinGripMid(mouse)) {
                        shape.grip.color = color;
                        drawSingle(shape.grip);
                        shape.grip.color = [0, 1, 0, 1];
                    }
                    break;
                case ObjectTypes.rectangle:
                    if (shape.isinGripP1(mouse) || shape.isinGripP2(mouse) || shape.isinGripP3(mouse) || shape.isinGripP4(mouse)
                    ) {
                        shape.grip.color = color;
                        drawSingle(shape.grip);
                        shape.grip.color = [0, 1, 0, 1];
                    }
                    break;
                case ObjectTypes.circle:
                    if (shape.isinGripQ1(mouse) || shape.isinGripQ2(mouse) || shape.isinGripQ3(mouse) || shape.isinGripQ4(mouse)) {
                        shape.grip.color = color;
                        drawSingle(shape.grip);
                        shape.grip.color = [0, 1, 0, 1];
                    }
                    break;
                default:
                    break;
            }
        });

    }

}

export function editModeObserver(mouse, shapes) {
    if (a.isMouseDown) {
        return;
    }

    else if (getMode() === 'select' || getMode() === 'edit' || getMode() === 'boundary') {
        shapes.filter(shape => shape.isSelected).forEach(shape => {
            switch (shape.type) {
                case ObjectTypes.line:
                    if (shape.isinGripStart(mouse) || shape.isinGripEnd(mouse)) {
                        shape.grip.color = [0, 0, 1, 1];
                        drawSingle(shape.grip);
                        shape.grip.color = [0, 1, 0, 1];
                        setMode('edit');
                    }
                    else {
                        if (!a.isMouseDown) {
                            setMode('select');

                        }
                    }
                    break;
                case ObjectTypes.rectangle:
                    if (shape.isinGripP1(mouse) || shape.isinGripP2(mouse) || shape.isinGripP3(mouse) || shape.isinGripP4(mouse)) {
                        shape.grip.color = [0, 0, 1, 1];
                        drawSingle(shape.grip);
                        shape.grip.color = [0, 1, 0, 1];
                        setMode('edit');
                    }
                    else {
                        if (!a.isMouseDown) {
                            setMode('select');
                        }
                    }
                    break;
                case ObjectTypes.circle:
                    if (shape.isinGripQ1(mouse) || shape.isinGripQ2(mouse) || shape.isinGripQ3(mouse) || shape.isinGripQ4(mouse)) {
                        shape.grip.color = [0, 0, 1, 1];
                        drawSingle(shape.grip);
                        shape.grip.color = [0, 1, 0, 1];

                        setMode('edit');
                    }
                    else {
                        if (!a.isMouseDown) {
                            setMode('select');
                        }
                    }
                    break;
                default:
                    break;
            }
        });

    }

}

var tooltipId;
export function boundaryModeObserver(mouse, shapes) {
    if (a.isMouseDown) {
        return;
    }

    t.editBoundary = false;

    if (['select', 'boundary', 'break'].includes(getMode())) {
        const isinSelectBoundary = getDisplayedShapes().filter(shape => checkFunction(shape, 'isinSelectBoundary', mouse));
        if (isinSelectBoundary.length > 0) {
            if (getMode() !== 'break') {
                setMode('boundary');
            }
            isinSelectBoundary.forEach(shape => {
                shape.setSelectBoundary();
                drawSingle(shape.selectBoundary);
                // create div element absolutely positioned according to the element position

                if (shape.isSelected && getMode() === 'boundary') {
                    let htmlMessage = null;
                    if (shape.type === ObjectTypes.line) {
                        let length = ((shape as any).getLength() / a.zlc).toFixed(1) + ' мм';
                        htmlMessage = `<div>
                                            <p><b>длина</b></p>
                                       </div>
                                       <div>
                                           <p>${length}</p>
                                       </div>`;

                    }
                    else if (shape.type === ObjectTypes.rectangle) {
                        let width = ((shape as any).getWidth() / a.zlc).toFixed(1) + ' мм';
                        let height = ((shape as any).getHeight() / a.zlc).toFixed(1) + ' мм';
                        htmlMessage = `<div>
                                           <p><b>ширина</b></p>
                                           <p><b>высота</b></p>
                                       </div>
                                       <div>
                                           <p>${width}</p>
                                           <p>${height}</p>
                                       </div>`;
                    }
                    else if (shape.type === ObjectTypes.circle) {
                        let radius = ((shape as any).getRadius() / a.zlc).toFixed(1) + ' мм';
                        htmlMessage = `<div>
                                           <p><b>радиус</b></p>
                                       </div>
                                       <div>
                                           <p>${radius}</p>
                                       </div>`;
                    }
                    tooltipId = addTooltipInfo(shape.id, shape.selectBoundary, htmlMessage);

                }
                else {
                    let tooltip = document.getElementById(tooltipId);
                    if (tooltip) {
                        document.body.removeChild(tooltip);
                    }
                }
            })
        }
        else {
            if (getMode() !== 'break') {
                setMode('select');
            }
            else {
                setMode('break');
            }
            let tooltip = document.getElementById(tooltipId);
            if (tooltip) {
                document.body.removeChild(tooltip);

            }

        }

    }
    else if ([cl.cm.networkHeating.type].includes(getMode())) {
        if (selectIfMouseInShapeBoundary(mouse)) {
            getSelectedShapes().forEach(s => {
                s.setSelectBoundary();
                drawSingle(s.selectBoundary);
            });
            resetSelectedShapes();
        }
    }
    else {
        // удалить все подсказки, если режим не select, boundary, break
        let tooltip = document.getElementById(tooltipId);
        if (tooltip) {
            document.body.removeChild(tooltip);
        }
    }
}
